export default "__VITE_ASSET__h_pJ53Vd__"